import angular from "angular";
import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";
import { DataService } from "../services/data.service";
import { EnsenyamentsDataService } from "../services/ensenyaments.service";
import { IApiSubetapa } from "../services/api.model";
import { CENTRES, EDUCACIO_ESPECIAL, TIPUS_SUPORT } from ".";

class Component {
  public pilotoOcultacioInclusiva;
  public ensenyaments: IApiSubetapa[];
  public showAdvancesCentres;
  public naturalesas = CENTRES;
  public eduEspecial = EDUCACIO_ESPECIAL;
  public tipusSuport = TIPUS_SUPORT;
  public selectedTab = null;
  public isEnsenyamentsOpen = false;
  public isCentresOpen = false;
  public centres = [];

  constructor(
    private $scope,
    private DataService: DataService,
    private EnsenyamentsData: EnsenyamentsDataService,
  ) { }

  $onInit() {
    this.setupListeners();
    this.EnsenyamentsData.init().then((ensenyaments) => {
      this.ensenyaments = ensenyaments;
      angular.extend(this.EnsenyamentsData.ensenyaments, this.ensenyaments);
    })
    this.showAdvancesCentres = this.DataService.cercarPer === 1;
    angular.extend(this.EnsenyamentsData.naturalesas, this.naturalesas);
    angular.extend(this.EnsenyamentsData.tipusSuport, this.tipusSuport);
    angular.extend(this.EnsenyamentsData.eduEspecial, this.eduEspecial);
    this.centres = [...this.naturalesas, ...this.tipusSuport, ...this.eduEspecial]
  }

  changeTab(value) {
    this.selectedTab = value;

    if (value === 0) {
      this.isCentresOpen = false;
      this.isEnsenyamentsOpen = !this.isEnsenyamentsOpen;
    } else {
      this.isEnsenyamentsOpen = false;
      this.isCentresOpen = !this.isCentresOpen;
    }
  };

  private setupListeners() {
    this.$scope.$on('clear', () => {
      angular.extend(this.ensenyaments, this.EnsenyamentsData.ensenyaments);
      angular.extend(this.naturalesas, this.EnsenyamentsData.naturalesas);
      angular.extend(this.eduEspecial, this.EnsenyamentsData.eduEspecial);
      angular.extend(this.tipusSuport, this.EnsenyamentsData.tipusSuport);
    }, true);

    this.$scope.$on('searchInit', () => {
      this.selectedTab = null;
      this.isEnsenyamentsOpen = false;
      this.isCentresOpen = false;
    });
  }
}

const component: ng.IComponentOptions = {
  bindings: {
    pilotoOcultacioInclusiva: '<',
  },
  templateUrl: './components/search-ofe.component.html',
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.SEARCH_OFE, component);